import { useEffect, useState } from "react";
import Confirmation from "../../components/confirmation";
import Footer from "../../components/footer";
import NavBar from "../../components/navbar";
import { useAuth } from "../../context/authprovider";
import { topicListApi } from "../../services/topic";
import { getUnbannedUserList } from "../../services/user";

export type UnbannedUserList = {
  id: number;
  username: string;
  givenName: string;
  lastName: string;
  email: string;
};

const BanUser = () => {
  const [unbannedUserList, setUnbannedUserList] =
    useState<UnbannedUserList[]>();
  const [deleteType, setDeleteType] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [selectedUserIndex, setSelectedUserIndex] = useState(-1);
  const { userId } = useAuth();

  useEffect(() => {
    const loadUnbannedList = async () => {
      const unbannedList = await getUnbannedUserList(userId!);
      if (unbannedList) {
        setUnbannedUserList(unbannedList.data.message);
      }
    };
    loadUnbannedList();
  }, []);

  return (
    <>
      <NavBar />
      <div className="mt-20">
        <div className="flex flex-wrap">
          <div className="xl:mx-72 h-fit bg-white object-center shadow overflow-hidden sm:rounded-md w-5/6">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      ID
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Username
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Full Name
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Email
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {unbannedUserList &&
                    unbannedUserList.map((unbannedUser) => (
                      <tr key={unbannedUser.id}>
                        {openModal && unbannedUser.id == selectedUserIndex && (
                          <Confirmation
                            show={openModal}
                            userId={userId!}
                            id={unbannedUser.id}
                            onToggle={setOpenModal}
                            selectedIndex={setSelectedUserIndex}
                            deleteType={deleteType}
                          />
                        )}
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                          {unbannedUser.id}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {unbannedUser.username}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {unbannedUser.givenName + " " + unbannedUser.lastName}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {unbannedUser.email}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                          <button
                          className="text-indigo-600 hover:text-indigo-900"
                            type="button"
                            onClick={() => {
                              setDeleteType("banUser");
                              setOpenModal(true);
                              setSelectedUserIndex(unbannedUser.id);
                            }}
                          >
                            Ban
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BanUser;
